
import './App.scss';
import {Routes,Route,useLocation} from 'react-router-dom';
import Particles from 'react-tsparticles';
import { loadSlim } from "tsparticles-slim";
import {loadFull} from 'react-tsparticles';
import { useCallback } from "react";
import Qawali from './containers/qawali';
import Naat from './containers/naat';
import About from './containers/about';
import Home from './containers/home';
import Navbar from './components/navBar';
import FireflyEffect from './LightningEffect';
import Footer from './components/footer';

function App() {
  const location =useLocation();
  console.log(location);
  

  const renderParticleJsInHomePage=location.pathname==='/';

  const handleInit= useCallback(async main=>{
    console.log(main);
     await loadSlim(main);
  }, []);
  const particlesLoaded = useCallback(async container => {
    await console.log(container);
}, []);
  return (
    <div className="App">
       {/*   particles js  */}
       <FireflyEffect />
        {
          renderParticleJsInHomePage 
        }
     
       {/*   navBar  */}
         <Navbar />

         {/*   main page content  */}
            <div className='App_main-page-content'>
            <Routes>
                <Route index path="/"  element={<Home/>}/>
                <Route  path="/about"  element={<About/>}/>
                <Route  path="/naat"  element={<Naat/>}/>
                <Route  path="/qawali"  element={<Qawali/>}/>
              
             
            </Routes>

       
            </div>

          
    </div>
  );
}

export default App;
